import CreateAccount from './CreateAccount';
import FirmInformation from './FirmInformation';
import Login from './Login';
import ResetPassword from './ResetPassword';
import ResetPasswordConfirmation from './ResetPasswordConfirmation';
import ScheduleDemo from './ScheduleDemo';

export {
  CreateAccount,
  FirmInformation,
  Login,
  ResetPassword,
  ResetPasswordConfirmation,
  ScheduleDemo,
};

export enum Modals {
  CreateAccount,
  FirmInformation,
  Login,
  ResetPassword,
  ResetPasswordConfirmation,
  ScheduleDemo,
}
